/**
 * Firebase Auth ActionCodeSettings for password reset (web / JS SDK only).
 *
 * **React Native (`@react-native-firebase/auth`):** call
 * `sendPasswordResetEmail(email)` with **no** second argument. Passing
 * `ActionCodeSettings` from the native SDK often returns `auth/internal-error`
 * after Dynamic Links are removed or the project link setup changes; the
 * continue URL then comes from the **Authentication → Templates** defaults.
 *
 * Web `url` hostname must be an **Authorized domain**
 * (Firebase Console → Authentication → Settings).
 *
 * @see https://firebase.google.com/docs/auth/web/passing-state-in-email-actions
 */
export const PASSWORD_RESET_CONTINUE_URL = "https://app.mighty45.com/signin";

/**
 * Coach console (browser): use the current origin so local dev matches the real route
 * (e.g. `http://localhost:3000/signin`) and production uses `https://app.mighty45.com/signin`.
 * Do not pass the result to React Native `sendPasswordResetEmail` — use email only there.
 */
export function getPasswordResetActionCodeSettings() {
  if (typeof window !== "undefined" && window.location?.origin) {
    const origin = window.location.origin.replace(/\/$/, "");
    return {
      url: `${origin}/signin`,
      handleCodeInApp: false,
    };
  }

  return {
    url: PASSWORD_RESET_CONTINUE_URL,
    handleCodeInApp: false,
  };
}
